// src/features/fourlink-config/utils/helpers/constants.js

export const WEEKDAY_OPTIONS = [
  { value: 'lunes', label: 'Lunes', short: 'Lun' },
  { value: 'martes', label: 'Martes', short: 'Mar' },
  { value: 'miercoles', label: 'Miercoles', short: 'Mie' },
  { value: 'jueves', label: 'Jueves', short: 'Jue' },
  { value: 'viernes', label: 'Viernes', short: 'Vie' },
  { value: 'sabado', label: 'Sabado', short: 'Sab' },
  { value: 'domingo', label: 'Domingo', short: 'Dom' },
];

export const WEEKDAY_ORDER = new Map(WEEKDAY_OPTIONS.map((option, index) => [option.value, index]));

export const DAYS_IN_MONTH = Array.from({ length: 31 }, (_, index) => index + 1);

export const TIPO_DATOS_OPTIONS = [
  { value: 'checklist', label: 'Checklist' },
  { value: 'registro', label: 'Registro' },
  { value: 'ninguno', label: 'Ninguno' },
];

export const PERIODICIDAD_OPTIONS = [
  { value: 'diaria', label: 'Diaria' },
  { value: 'semanal', label: 'Semanal' },
  { value: 'mensual', label: 'Mensual' },
  { value: 'esporadica', label: 'Esporadica' },
  { value: 'ninguna', label: 'Ninguna' },
];

export const STORAGE_KEY = 'fourlink-config-tool-state-v1';
export const SCHEDULES_STORAGE_KEY = 'fourlink-config-tool-schedules-v1';
